import { useMutation } from "@tanstack/react-query";
import { anonymizePrompt } from "../services/compass.service";
import { IAnonymizePromptRequest, IAnonymizePromptResponse } from "../types/compass.types";

export const useAnonymizePrompt = () => {
  return useMutation<IAnonymizePromptResponse, Error, IAnonymizePromptRequest>({
    mutationFn: (data) => anonymizePrompt(data),
  });
};
